/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Toggle_SubpagesInputs */

const sv_toggle_subpages = /** @type {(inputs: Toggle_SubpagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visa eller dölj undersidor för ${i?.label}`)
};

const en_toggle_subpages = /** @type {(inputs: Toggle_SubpagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toggle ${i?.label} subpages`)
};

/**
* | output |
* | --- |
* | "Toggle {label} subpages" |
*
* @param {Toggle_SubpagesInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const toggle_subpages = /** @type {((inputs: Toggle_SubpagesInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_SubpagesInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_toggle_subpages(inputs)
	return en_toggle_subpages(inputs)
});